export default __webpack_public_path__ + "static/media/li-logo.115d3af0.svg";